import React from 'react';
import {Box, Button, Chip, Grid, Paper, Typography} from '@mui/material';
import {SubdirectoryArrowRight} from '@mui/icons-material';
import {themeColors} from '../../../../theme/Theme';
import {OVRecommendation} from '../../../../schema-types/OVRecommendation';
import LoadingSpinnerIcon from '../../../../theme/styled-components/LoadingSpinnerIcon';
import {OpenInCuro} from '../../../../utils/getCuroURL';

const classes = {
  tableCell: {
    flex: 1,
    lineHeight: 1,
  },
};

export const SPPDetailPanel: React.FC<{
  row: OVRecommendation;
  loading: boolean;
}> = ({row, loading}) => {
  const colorScheme: Record<string, string> = {
    Amber: themeColors.amber,
    Green: themeColors.green,
    Red: themeColors.red,
    'Light Green': themeColors.lightGreen,
    'Light Red': themeColors.coral,
    default: themeColors.greyLight,
  };

  return (
    <Paper style={{padding: '1rem', backgroundColor: themeColors.greyLight}}>
      {row.recommends?.map((rec) => {
        const projects = rec.projects ?? [];
        return (
          <Grid container key={rec.id}>
            <Grid item xs={12}>
              {rec?.advice}
              <OpenInCuro
                curoType="recommendation"
                curoId={rec?.curoId}
                alwaysShow
                variant="contained"
                sx={{
                  marginLeft: '2rem',
                }}
              >
                Open instruction in curo
              </OpenInCuro>
            </Grid>
            <Grid item xs={12}>
              {projects.map((proj) => {
                if (!rec || loading) {
                  return null;
                }
                const isInColorScheme = (proj?.stage?.colour || '') in colorScheme;
                return (
                  <Box width={300} marginLeft={10} key={proj.id}>
                    <div
                      style={{
                        ...classes.tableCell,
                        display: 'flex',
                        alignContent: 'flex-start',
                        marginBottom: 0.5,
                        alignItems: 'center',
                      }}
                    >
                      <SubdirectoryArrowRight htmlColor="grey" />
                      <Chip
                        label={proj?.stage?.mappedName}
                        sx={{
                          background: isInColorScheme
                            ? colorScheme[proj?.stage?.colour || '']
                            : colorScheme.default,
                        }}
                      />
                      <Box flex={1} ml={1}>
                        {proj.stage?.projectCategory?.mappedName}
                      </Box>
                    </div>
                  </Box>
                );
              })}
            </Grid>
          </Grid>
        );
      })}
      {loading ? (
        <div>
          <Box mt={2} display="flex">
            <LoadingSpinnerIcon />{' '}
            <Typography ml={2}>Getting latest status...</Typography>
          </Box>
        </div>
      ) : null}
    </Paper>
  );
};
